export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      services: 'Services',
      vehicles: 'Véhicules',
      pricing: 'Tarifs',
      contact: 'Contact',
      book: 'Réserver',
      backToSite: 'Retour au site',
      administration: 'Administration',
    },
    hero: {
      tagline: 'Transport premium sur la Côte d\'Azur',
      description: 'Service de VTC haut de gamme offrant des trajets élégants et sereins entre Nice, Cannes, Monaco et les principales destinations régionales. Chaque déplacement bénéficie d\'une prise en charge personnalisée, alliant ponctualité, discrétion et confort.',
      bookNow: 'Réserver maintenant',
      discoverServices: 'Découvrir les services',
      since: 'Depuis',
      service: 'Service',
      satisfaction: 'Satisfaction',
    },
    services: {
      title: 'Services Premium',
      subtitle: 'Une gamme complète de services de transport haut de gamme, adaptés à tous vos besoins personnels et professionnels.',
      customService: 'Besoin d\'un service sur-mesure ?',
      requestQuote: 'Demander un devis personnalisé →',
      privateTransfer: 'Transfert Privé',
      privateTransferDesc: 'Transport privé pour vos déplacements quotidiens sur la Côte d\'Azur',
      airportTransfer: 'Transfert Aéroport',
      airportTransferDesc: 'Service de transfert vers l\'aéroport Nice Côte d\'Azur et tous les aéroports de la région',
      trainTransfer: 'Transfert Gare',
      trainTransferDesc: 'Liaisons confortables vers toutes les gares de la Côte d\'Azur avec ponctualité garantie',
      disposal: 'Mise à Disposition',
      disposalDesc: 'Véhicule et chauffeur à votre disposition pour vos déplacements sur la Côte d\'Azur',
      eventTransfer: 'Transfert Événement',
      eventTransferDesc: 'Transport premium pour vos événements, mariages et soirées sur la Riviera',
      features: {
        customTrips: 'Trajets personnalisés',
        pickupAddress: 'Prise en charge à l\'adresse souhaitée',
        punctuality: 'Ponctualité assurée',
        flexiblePayment: 'Paiement flexible',
        flightTracking: 'Suivi de vol en temps réel',
        personalWelcome: 'Accueil personnalisé',
        luggageHelp: 'Aide aux bagages',
        waitTimeIncluded: 'Temps d\'attente inclus',
        niceStation: 'Gare de Nice-Ville',
        cannesStation: 'Gare de Cannes',
        monacoStation: 'Gare de Monaco',
        trainTracking: 'Suivi temps réel des trains',
        dedicatedDriver: 'Chauffeur dédié',
        totalFlexibility: 'Flexibilité totale',
        waitIncluded: 'Attente incluse',
        multipleTrips: 'Trajets multiples',
        immaculateVehicle: 'Véhicule immaculé',
        eveningAttire: 'Tenue de soirée chauffeur',
        discretionGuaranteed: 'Discrétion garantie',
        flexibleSchedule: 'Horaires flexibles',
      },
    },
    vehicles: {
      title: 'Véhicule Premium',
      subtitle: 'Citroën C4 Plus 2025, entretenue avec le plus grand soin, pour vous garantir confort, silence et sérénité.',
      passengers: 'passagers',
      luggage: 'bagages',
      includedEquipment: 'Équipements inclus :',
      bookVehicle: 'Réserver ce véhicule',
      requestQuote: 'Demander un devis personnalisé →',
      availability: 'Citroën C4 Plus disponible 24/7 sur la Côte d\'Azur',
      availabilityDesc: 'Véhicule hybride dernière génération avec technologie Advanced Comfort. Entretien officiel, assurance tous risques, et chauffeur expérimenté pour chaque trajet.',
      bookNow: 'Réserver maintenant',
      category: 'Berline Hybride Premium',
      features: {
        spacious: 'Habitacle spacieux et silencieux',
        acoustic: 'Isolation acoustique renforcée',
        suspension: 'Suspensions Advanced Comfort',
        seats: 'Sièges Advanced Comfort ',
        hybrid: 'Motorisation hybride silencieuse en ville',
      },
    },
    pricing: {
      title: 'Tarifs Transparents',
      subtitle: 'Des prix justes, connus à l\'avance. Aucuns frais cachés, pour un service en toute confiance.',
      tollIncluded: 'Frais de péage inclus',
      book: 'Réserver',
      fixedPrices: 'Prix fixes',
      fixedPricesDesc: 'Tarifs établis à l\'avance, pas de surprise sur la facture finale.',
      allInclusive: 'Tout inclus',
      allInclusiveDesc: 'Frais de service, péages et assurance inclus dans les tarifs.',
      flexiblePayment: 'Paiement flexible',
      flexiblePaymentDesc: 'Espèces, carte bancaire ou virement, choisissez votre mode de paiement.',
      customQuote: 'Besoin d\'un tarif personnalisé ?',
      customQuoteDesc: 'Chaque demande mérite une attention particulière. Un tarif sur-mesure est disponible pour vos besoins spécifiques.',
      requestQuote: 'Demander un devis',
      priceDesc: 'Tarif final calculé selon adresse réservée.',
    },
    reviews: {
      title: 'Avis Google',
      googleReviews: 'avis Google',
      subtitle: 'Découvrez ce que les clients pensent des services Riviera Signature VTC.',
      yourOpinionMatters: 'Votre avis compte',
      shareExperience: 'Vous avez utilisé nos services ? Partagez votre expérience avec la communauté et aidez d\'autres voyageurs à découvrir Riviera Signature VTC.',
      seeAllReviews: 'Voir tous les avis Google →',
      googleRating: 'Note Google',
      recommended: 'Recommandé',
      responseTime: 'Réponse avis',
      since: 'Depuis',
      reviewTexts: {
        review1: 'Service exceptionnel ! Trajet Nice-Monaco dans un confort total et en silence. Chauffeur très professionnel et ponctuel. Je recommande vivement pour tous vos déplacements sur la Côte d\'Azur.',
        review2: 'Riviera Signature VTC est maintenant mon choix exclusif pour les transferts aéroport. Véhicule toujours impeccable, très confortable. Service premium à prix correct.',
        review3: 'Nous avons utilisé Riviera Signature VTC pour notre mariage à Cannes. Service irréprochable, véhicule somptueux. Parfait pour une arrivée remarquée.',
        review4: 'Mise à disposition pour une journée de réunions entre Nice et Monaco. Véhicule très confortable, silence de roulage appréciable pour téléphoner. Chauffeur discret et professionnel.',
      },
      timeAgo: {
        week1: 'il y a 1 semaine',
        weeks2: 'il y a 2 semaines',
        weeks3: 'il y a 3 semaines',
        month1: 'il y a 1 mois',
      },
    },
    contact: {
      title: 'Contact',
      subtitle: 'Chauffeur à votre disposition 24h/24 et 7j/7 pour répondre à toutes vos demandes et vous accompagner dans vos déplacements.',
      coordinates: 'Coordonnées',
      phone: 'Téléphone',
      available247: 'Disponible 24h/24, 7j/7',
      email: 'Email',
      responseTime: 'Réponse sous 2h en moyenne',
      serviceArea: 'Zone de service',
      serviceHours: 'Horaires de service',
      mondaySunday: 'Lundi - Dimanche',
      allDay: '24h/24',
      holidays: 'Jours fériés',
      serviceMaintained: 'Service maintenu',
      reservations: 'Réservations',
      onlineOrPhone: 'En ligne ou par téléphone',
      quickContact: 'Contact rapide',
      firstName: 'Prénom',
      lastName: 'Nom',
      phonePlaceholder: 'Téléphone',
      emailPlaceholder: 'Email',
      subjectPlaceholder: 'Sujet de votre demande',
      subjects: {
        reservation: 'Réservation',
        information: 'Demande d\'information',
        quote: 'Demande de devis',
        complaint: 'Réclamation',
        other: 'Autre',
      },
      messagePlaceholder: 'Votre message...',
      sendMessage: 'Envoyer le message',
      followUs: 'Suivez-nous',
    },
    footer: {
      description: 'Transport premium sur la Côte d\'Azur avec Citroën C4 Plus 2025.',
      services: 'Services',
      privateTransfer: 'Transfert Privé',
      airportTransfer: 'Transfert Aéroport',
      trainTransfer: 'Transfert Gare',
      disposal: 'Mise à Disposition',
      eventTransfer: 'Transfert Événements',
      contact: 'Contact',
      allRightsReserved: 'Tous droits réservés.',
    },
    booking: {
      title: 'Demande de réservation',
      serviceType: 'Type de service *',
      selectService: 'Sélectionnez un service',
      pickupDate: 'Date de prise en charge *',
      time: 'Heure *',
      pickupAddress: 'Adresse de prise en charge *',
      pickupPlaceholder: 'Adresse complète de départ / aéroport / gare',
      destination: 'Destination',
      destinationPlaceholder: 'Adresse / aéroport / gare / restaurant',
      passengers: 'Nombre de passagers',
      passenger: 'passager',
      passengersPlural: 'passagers',
      yourInfo: 'Vos informations',
      fullName: 'Nom complet *',
      namePlaceholder: 'Votre nom et prénom',
      phone: 'Téléphone *',
      email: 'Email *',
      notes: 'Notes particulières',
      notesPlaceholder: 'Infos complémentaires (siège bébé, bagages volumineux, etc.)',
      cancel: 'Annuler',
      sendRequest: 'Envoyer la demande',
      sending: 'Envoi en cours...',
      estimatedDistance: 'Distance estimée',
      estimatedPrice: 'Prix estimé',
      error: 'Erreur',
      fillRequired: 'Veuillez remplir tous les champs obligatoires.',
      reservationSent: 'Réservation envoyée ! ✅',
      requestSent: 'Votre demande a été envoyée avec l\'ID',
      emailError: 'Erreur d\'envoi d\'e-mail',
      emailErrorDesc: 'Une erreur s\'est produite lors de l\'envoi des e-mails de confirmation. Veuillez nous contacter directement.',
      reservationSentSimple: 'Votre réservation a été envoyée.',
      serviceTypes: {
        transfer: 'Transfert',
        airportTrain: 'Transfert aéroport/gare',
        disposal: 'Mise à disposition',
        event: 'Transfert événement',
      },
    },
    common: {
      darkMode: 'Mode sombre',
      lightMode: 'Mode clair',
    },
  },

  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      vehicles: 'Vehicles',
      pricing: 'Pricing',
      contact: 'Contact',
      book: 'Book',
      backToSite: 'Back to site',
      administration: 'Administration',
    },
    hero: {
      tagline: 'Premium transport on the French Riviera',
      description: 'High-end VTC service offering elegant and serene journeys between Nice, Cannes, Monaco and major regional destinations. Each trip benefits from personalized care, combining punctuality, discretion and comfort.',
      bookNow: 'Book now',
      discoverServices: 'Discover services',
      since: 'Since',
      service: 'Service',
      satisfaction: 'Satisfaction',
    },
    services: {
      title: 'Premium Services',
      subtitle: 'A complete range of high-end transportation services, tailored to all your personal and professional needs.',
      customService: 'Need a custom service?',
      requestQuote: 'Request a personalized quote →',
      privateTransfer: 'Private Transfer',
      privateTransferDesc: 'Private transport for your daily trips on the French Riviera',
      airportTransfer: 'Airport Transfer',
      airportTransferDesc: 'Transfer service to Nice Côte d\'Azur airport and all regional airports',
      trainTransfer: 'Train Station Transfer',
      trainTransferDesc: 'Comfortable connections to all French Riviera train stations with guaranteed punctuality',
      disposal: 'At Your Disposal',
      disposalDesc: 'Vehicle and driver at your disposal for your trips on the French Riviera',
      eventTransfer: 'Event Transfer',
      eventTransferDesc: 'Premium transport for your events, weddings and parties on the Riviera',
      features: {
        customTrips: 'Custom trips',
        pickupAddress: 'Pickup at your address',
        punctuality: 'Guaranteed punctuality',
        flexiblePayment: 'Flexible payment',
        flightTracking: 'Real-time flight tracking',
        personalWelcome: 'Personal welcome',
        luggageHelp: 'Luggage assistance',
        waitTimeIncluded: 'Wait time included',
        niceStation: 'Nice-Ville Station',
        cannesStation: 'Cannes Station',
        monacoStation: 'Monaco Station',
        trainTracking: 'Real-time train tracking',
        dedicatedDriver: 'Dedicated driver',
        totalFlexibility: 'Total flexibility',
        waitIncluded: 'Wait included',
        multipleTrips: 'Multiple trips',
        immaculateVehicle: 'Immaculate vehicle',
        eveningAttire: 'Driver in evening attire',
        discretionGuaranteed: 'Guaranteed discretion',
        flexibleSchedule: 'Flexible schedule',
      },
    },
    vehicles: {
      title: 'Premium Vehicle',
      subtitle: 'Citroën C4 Plus 2025, maintained with the utmost care, to guarantee you comfort, silence and serenity.',
      passengers: 'passengers',
      luggage: 'luggage',
      includedEquipment: 'Included equipment:',
      bookVehicle: 'Book this vehicle',
      requestQuote: 'Request a personalized quote →',
      availability: 'Citroën C4 Plus available 24/7 on the French Riviera',
      availabilityDesc: 'Latest generation hybrid vehicle with Advanced Comfort technology. Official maintenance, comprehensive insurance, and experienced driver for each trip.',
      bookNow: 'Book now',
      category: 'Premium Hybrid Sedan',
      features: {
        spacious: 'Spacious and silent interior',
        acoustic: 'Reinforced acoustic insulation',
        suspension: 'Advanced Comfort suspensions',
        seats: 'Advanced Comfort seats ',
        hybrid: 'Silent hybrid engine in city',
      },
    },
    pricing: {
      title: 'Transparent Pricing',
      subtitle: 'Fair prices, known in advance. No hidden fees, for a service in complete confidence.',
      tollIncluded: 'Toll fees included',
      book: 'Book',
      fixedPrices: 'Fixed prices',
      fixedPricesDesc: 'Rates established in advance, no surprises on the final bill.',
      allInclusive: 'All inclusive',
      allInclusiveDesc: 'Service fees, tolls and insurance included in the rates.',
      flexiblePayment: 'Flexible payment',
      flexiblePaymentDesc: 'Cash, credit card or transfer, choose your payment method.',
      customQuote: 'Need a custom rate?',
      customQuoteDesc: 'Each request deserves special attention. A custom rate is available for your specific needs.',
      requestQuote: 'Request a quote',
      priceDesc: 'Final price calculated based on reserved address.',
    },
    reviews: {
      title: 'Google Reviews',
      googleReviews: 'Google reviews',
      subtitle: 'Discover what customers think of Riviera Signature VTC services.',
      yourOpinionMatters: 'Your opinion matters',
      shareExperience: 'Have you used our services? Share your experience with the community and help other travelers discover Riviera Signature VTC.',
      seeAllReviews: 'See all Google reviews →',
      googleRating: 'Google Rating',
      recommended: 'Recommended',
      responseTime: 'Review response',
      since: 'Since',
      reviewTexts: {
        review1: 'Exceptional service! Nice-Monaco trip in total comfort and silence. Very professional and punctual driver. I highly recommend for all your trips on the French Riviera.',
        review2: 'Riviera Signature VTC is now my exclusive choice for airport transfers. Always impeccable vehicle, very comfortable. Premium service at fair price.',
        review3: 'We used Riviera Signature VTC for our wedding in Cannes. Impeccable service, sumptuous vehicle. Perfect for a remarkable arrival.',
        review4: 'At disposal for a day of meetings between Nice and Monaco. Very comfortable vehicle, appreciable quiet ride for phone calls. Discreet and professional driver.',
      },
      timeAgo: {
        week1: '1 week ago',
        weeks2: '2 weeks ago',
        weeks3: '3 weeks ago',
        month1: '1 month ago',
      },
    },
    contact: {
      title: 'Contact',
      subtitle: 'Driver at your disposal 24/7 to answer all your requests and accompany you in your travels.',
      coordinates: 'Contact Information',
      phone: 'Phone',
      available247: 'Available 24/7',
      email: 'Email',
      responseTime: 'Average response time 2h',
      serviceArea: 'Service area',
      serviceHours: 'Service hours',
      mondaySunday: 'Monday - Sunday',
      allDay: '24/7',
      holidays: 'Holidays',
      serviceMaintained: 'Service maintained',
      reservations: 'Reservations',
      onlineOrPhone: 'Online or by phone',
      quickContact: 'Quick contact',
      firstName: 'First name',
      lastName: 'Last name',
      phonePlaceholder: 'Phone',
      emailPlaceholder: 'Email',
      subjectPlaceholder: 'Subject of your request',
      subjects: {
        reservation: 'Reservation',
        information: 'Information request',
        quote: 'Quote request',
        complaint: 'Complaint',
        other: 'Other',
      },
      messagePlaceholder: 'Your message...',
      sendMessage: 'Send message',
      followUs: 'Follow us',
    },
    footer: {
      description: 'Premium transport on the French Riviera with Citroën C4 Plus 2025.',
      services: 'Services',
      privateTransfer: 'Private Transfer',
      airportTransfer: 'Airport Transfer',
      trainTransfer: 'Train Station Transfer',
      disposal: 'At Your Disposal',
      eventTransfer: 'Event Transfer',
      contact: 'Contact',
      allRightsReserved: 'All rights reserved.',
    },
    booking: {
      title: 'Booking request',
      serviceType: 'Service type *',
      selectService: 'Select a service',
      pickupDate: 'Pickup date *',
      time: 'Time *',
      pickupAddress: 'Pickup address *',
      pickupPlaceholder: 'Full departure address / airport / station',
      destination: 'Destination',
      destinationPlaceholder: 'Address / airport / station / restaurant',
      passengers: 'Number of passengers',
      passenger: 'passenger',
      passengersPlural: 'passengers',
      yourInfo: 'Your information',
      fullName: 'Full name *',
      namePlaceholder: 'Your name',
      phone: 'Phone *',
      email: 'Email *',
      notes: 'Special notes',
      notesPlaceholder: 'Additional info (baby seat, large luggage, etc.)',
      cancel: 'Cancel',
      sendRequest: 'Send request',
      sending: 'Sending...',
      estimatedDistance: 'Estimated distance',
      estimatedPrice: 'Estimated price',
      error: 'Error',
      fillRequired: 'Please fill in all required fields.',
      reservationSent: 'Reservation sent! ✅',
      requestSent: 'Your request has been sent with ID',
      emailError: 'Email sending error',
      emailErrorDesc: 'An error occurred while sending confirmation emails. Please contact us directly.',
      reservationSentSimple: 'Your reservation has been sent.',
      serviceTypes: {
        transfer: 'Transfer',
        airportTrain: 'Airport/station transfer',
        disposal: 'At your disposal',
        event: 'Event transfer',
      },
    },
    common: {
      darkMode: 'Dark mode',
      lightMode: 'Light mode',
    },
  },

  it: {
    nav: {
      home: 'Home',
      services: 'Servizi',
      vehicles: 'Veicoli',
      pricing: 'Tariffe',
      contact: 'Contatto',
      book: 'Prenota',
      backToSite: 'Torna al sito',
      administration: 'Amministrazione',
    },
    hero: {
      tagline: 'Trasporto premium sulla Costa Azzurra',
      description: 'Servizio VTC di alta gamma che offre viaggi eleganti e sereni tra Nizza, Cannes, Monaco e le principali destinazioni regionali. Ogni viaggio beneficia di un\'attenzione personalizzata, combinando puntualità, discrezione e comfort.',
      bookNow: 'Prenota ora',
      discoverServices: 'Scopri i servizi',
      since: 'Dal',
      service: 'Servizio',
      satisfaction: 'Soddisfazione',
    },
    services: {
      title: 'Servizi Premium',
      subtitle: 'Una gamma completa di servizi di trasporto di alta gamma, adattati a tutte le vostre esigenze personali e professionali.',
      customService: 'Hai bisogno di un servizio su misura?',
      requestQuote: 'Richiedi un preventivo personalizzato →',
      privateTransfer: 'Trasferimento Privato',
      privateTransferDesc: 'Trasporto privato per i tuoi spostamenti quotidiani sulla Costa Azzurra',
      airportTransfer: 'Trasferimento Aeroporto',
      airportTransferDesc: 'Servizio di trasferimento verso l\'aeroporto di Nizza Costa Azzurra e tutti gli aeroporti della regione',
      trainTransfer: 'Trasferimento Stazione',
      trainTransferDesc: 'Collegamenti confortevoli verso tutte le stazioni della Costa Azzurra con puntualità garantita',
      disposal: 'A Disposizione',
      disposalDesc: 'Veicolo e autista a vostra disposizione per i vostri spostamenti sulla Costa Azzurra',
      eventTransfer: 'Trasferimento Evento',
      eventTransferDesc: 'Trasporto premium per i vostri eventi, matrimoni e serate sulla Riviera',
      features: {
        customTrips: 'Viaggi personalizzati',
        pickupAddress: 'Prelievo all\'indirizzo desiderato',
        punctuality: 'Puntualità garantita',
        flexiblePayment: 'Pagamento flessibile',
        flightTracking: 'Monitoraggio volo in tempo reale',
        personalWelcome: 'Accoglienza personalizzata',
        luggageHelp: 'Assistenza bagagli',
        waitTimeIncluded: 'Tempo di attesa incluso',
        niceStation: 'Stazione di Nizza',
        cannesStation: 'Stazione di Cannes',
        monacoStation: 'Stazione di Monaco',
        trainTracking: 'Monitoraggio treni in tempo reale',
        dedicatedDriver: 'Autista dedicato',
        totalFlexibility: 'Flessibilità totale',
        waitIncluded: 'Attesa inclusa',
        multipleTrips: 'Viaggi multipli',
        immaculateVehicle: 'Veicolo immacolato',
        eveningAttire: 'Autista in abito da sera',
        discretionGuaranteed: 'Discrezione garantita',
        flexibleSchedule: 'Orari flessibili',
      },
    },
    vehicles: {
      title: 'Veicolo Premium',
      subtitle: 'Citroën C4 Plus 2025, mantenuta con la massima cura, per garantirvi comfort, silenzio e serenità.',
      passengers: 'passeggeri',
      luggage: 'bagagli',
      includedEquipment: 'Equipaggiamento incluso:',
      bookVehicle: 'Prenota questo veicolo',
      requestQuote: 'Richiedi un preventivo personalizzato →',
      availability: 'Citroën C4 Plus disponibile 24/7 sulla Costa Azzurra',
      availabilityDesc: 'Veicolo ibrido ultima generazione con tecnologia Advanced Comfort. Manutenzione ufficiale, assicurazione completa e autista esperto per ogni viaggio.',
      bookNow: 'Prenota ora',
      category: 'Berlina Ibrida Premium',
      features: {
        spacious: 'Abitacolo spazioso e silenzioso',
        acoustic: 'Isolamento acustico rinforzato',
        suspension: 'Sospensioni Advanced Comfort',
        seats: 'Sedili Advanced Comfort ',
        hybrid: 'Motorizzazione ibrida silenziosa in città',
      },
    },
    pricing: {
      title: 'Tariffe Trasparenti',
      subtitle: 'Prezzi giusti, noti in anticipo. Nessun costo nascosto, per un servizio in totale fiducia.',
      tollIncluded: 'Pedaggi inclusi',
      book: 'Prenota',
      fixedPrices: 'Prezzi fissi',
      fixedPricesDesc: 'Tariffe stabilite in anticipo, nessuna sorpresa sulla fattura finale.',
      allInclusive: 'Tutto incluso',
      allInclusiveDesc: 'Spese di servizio, pedaggi e assicurazione inclusi nelle tariffe.',
      flexiblePayment: 'Pagamento flessibile',
      flexiblePaymentDesc: 'Contanti, carta di credito o bonifico, scegli il tuo metodo di pagamento.',
      customQuote: 'Hai bisogno di una tariffa personalizzata?',
      customQuoteDesc: 'Ogni richiesta merita un\'attenzione particolare. Una tariffa su misura è disponibile per le vostre esigenze specifiche.',
      requestQuote: 'Richiedi un preventivo',
      priceDesc: 'Prezzo finale calcolato in base all\'indirizzo prenotato.',
    },
    reviews: {
      title: 'Recensioni Google',
      googleReviews: 'recensioni Google',
      subtitle: 'Scopri cosa pensano i clienti dei servizi Riviera Signature VTC.',
      yourOpinionMatters: 'La tua opinione conta',
      shareExperience: 'Hai utilizzato i nostri servizi? Condividi la tua esperienza con la comunità e aiuta altri viaggiatori a scoprire Riviera Signature VTC.',
      seeAllReviews: 'Vedi tutte le recensioni Google →',
      googleRating: 'Valutazione Google',
      recommended: 'Consigliato',
      responseTime: 'Risposta recensioni',
      since: 'Dal',
      reviewTexts: {
        review1: 'Servizio eccezionale! Viaggio Nizza-Monaco in totale comfort e silenzio. Autista molto professionale e puntuale. Consiglio vivamente per tutti i vostri spostamenti sulla Costa Azzurra.',
        review2: 'Riviera Signature VTC è ora la mia scelta esclusiva per i trasferimenti aeroportuali. Veicolo sempre impeccabile, molto confortevole. Servizio premium a prezzo corretto.',
        review3: 'Abbiamo utilizzato Riviera Signature VTC per il nostro matrimonio a Cannes. Servizio impeccabile, veicolo sontuoso. Perfetto per un arrivo notevole.',
        review4: 'A disposizione per una giornata di riunioni tra Nizza e Monaco. Veicolo molto confortevole, silenziosità di marcia apprezzabile per telefonare. Autista discreto e professionale.',
      },
      timeAgo: {
        week1: '1 settimana fa',
        weeks2: '2 settimane fa',
        weeks3: '3 settimane fa',
        month1: '1 mese fa',
      },
    },
    contact: {
      title: 'Contatto',
      subtitle: 'Autista a vostra disposizione 24h/24 e 7g/7 per rispondere a tutte le vostre richieste e accompagnarvi nei vostri spostamenti.',
      coordinates: 'Coordinate',
      phone: 'Telefono',
      available247: 'Disponibile 24h/24, 7g/7',
      email: 'Email',
      responseTime: 'Risposta media in 2h',
      serviceArea: 'Zona di servizio',
      serviceHours: 'Orari di servizio',
      mondaySunday: 'Lunedì - Domenica',
      allDay: '24h/24',
      holidays: 'Giorni festivi',
      serviceMaintained: 'Servizio mantenuto',
      reservations: 'Prenotazioni',
      onlineOrPhone: 'Online o per telefono',
      quickContact: 'Contatto rapido',
      firstName: 'Nome',
      lastName: 'Cognome',
      phonePlaceholder: 'Telefono',
      emailPlaceholder: 'Email',
      subjectPlaceholder: 'Oggetto della richiesta',
      subjects: {
        reservation: 'Prenotazione',
        information: 'Richiesta informazioni',
        quote: 'Richiesta preventivo',
        complaint: 'Reclamo',
        other: 'Altro',
      },
      messagePlaceholder: 'Il tuo messaggio...',
      sendMessage: 'Invia messaggio',
      followUs: 'Seguici',
    },
    footer: {
      description: 'Trasporto premium sulla Costa Azzurra con Citroën C4 Plus 2025.',
      services: 'Servizi',
      privateTransfer: 'Trasferimento Privato',
      airportTransfer: 'Trasferimento Aeroporto',
      trainTransfer: 'Trasferimento Stazione',
      disposal: 'A Disposizione',
      eventTransfer: 'Trasferimento Eventi',
      contact: 'Contatto',
      allRightsReserved: 'Tutti i diritti riservati.',
    },
    booking: {
      title: 'Richiesta di prenotazione',
      serviceType: 'Tipo di servizio *',
      selectService: 'Seleziona un servizio',
      pickupDate: 'Data di prelievo *',
      time: 'Ora *',
      pickupAddress: 'Indirizzo di prelievo *',
      pickupPlaceholder: 'Indirizzo completo / aeroporto / stazione',
      destination: 'Destinazione',
      destinationPlaceholder: 'Indirizzo / aeroporto / stazione / ristorante',
      passengers: 'Numero di passeggeri',
      passenger: 'passeggero',
      passengersPlural: 'passeggeri',
      yourInfo: 'Le tue informazioni',
      fullName: 'Nome completo *',
      namePlaceholder: 'Il tuo nome',
      phone: 'Telefono *',
      email: 'Email *',
      notes: 'Note particolari',
      notesPlaceholder: 'Info aggiuntive (seggiolino, bagagli ingombranti, ecc.)',
      cancel: 'Annulla',
      sendRequest: 'Invia richiesta',
      sending: 'Invio in corso...',
      estimatedDistance: 'Distanza stimata',
      estimatedPrice: 'Prezzo stimato',
      error: 'Errore',
      fillRequired: 'Compila tutti i campi obbligatori.',
      reservationSent: 'Prenotazione inviata! ✅',
      requestSent: 'La tua richiesta è stata inviata con ID',
      emailError: 'Errore invio email',
      emailErrorDesc: 'Si è verificato un errore durante l\'invio delle email di conferma. Contattaci direttamente.',
      reservationSentSimple: 'La tua prenotazione è stata inviata.',
      serviceTypes: {
        transfer: 'Trasferimento',
        airportTrain: 'Trasferimento aeroporto/stazione',
        disposal: 'A disposizione',
        event: 'Trasferimento evento',
      },
    },
    common: {
      darkMode: 'Modalità scura',
      lightMode: 'Modalità chiara',
    },
  },

  es: {
    nav: {
      home: 'Inicio',
      services: 'Servicios',
      vehicles: 'Vehículos',
      pricing: 'Tarifas',
      contact: 'Contacto',
      book: 'Reservar',
      backToSite: 'Volver al sitio',
      administration: 'Administración',
    },
    hero: {
      tagline: 'Transporte premium en la Costa Azul',
      description: 'Servicio VTC de alta gama que ofrece viajes elegantes y serenos entre Niza, Cannes, Mónaco y los principales destinos regionales. Cada viaje se beneficia de una atención personalizada, combinando puntualidad, discreción y confort.',
      bookNow: 'Reservar ahora',
      discoverServices: 'Descubrir servicios',
      since: 'Desde',
      service: 'Servicio',
      satisfaction: 'Satisfacción',
    },
    services: {
      title: 'Servicios Premium',
      subtitle: 'Una gama completa de servicios de transporte de alta gama, adaptados a todas sus necesidades personales y profesionales.',
      customService: '¿Necesita un servicio a medida?',
      requestQuote: 'Solicitar presupuesto personalizado →',
      privateTransfer: 'Traslado Privado',
      privateTransferDesc: 'Transporte privado para sus desplazamientos diarios en la Costa Azul',
      airportTransfer: 'Traslado Aeropuerto',
      airportTransferDesc: 'Servicio de traslado al aeropuerto de Niza Costa Azul y todos los aeropuertos de la región',
      trainTransfer: 'Traslado Estación',
      trainTransferDesc: 'Conexiones cómodas a todas las estaciones de la Costa Azul con puntualidad garantizada',
      disposal: 'A Disposición',
      disposalDesc: 'Vehículo y conductor a su disposición para sus desplazamientos en la Costa Azul',
      eventTransfer: 'Traslado Evento',
      eventTransferDesc: 'Transporte premium para sus eventos, bodas y fiestas en la Riviera',
      features: {
        customTrips: 'Viajes personalizados',
        pickupAddress: 'Recogida en la dirección deseada',
        punctuality: 'Puntualidad garantizada',
        flexiblePayment: 'Pago flexible',
        flightTracking: 'Seguimiento de vuelo en tiempo real',
        personalWelcome: 'Bienvenida personalizada',
        luggageHelp: 'Asistencia con equipaje',
        waitTimeIncluded: 'Tiempo de espera incluido',
        niceStation: 'Estación de Niza',
        cannesStation: 'Estación de Cannes',
        monacoStation: 'Estación de Mónaco',
        trainTracking: 'Seguimiento de trenes en tiempo real',
        dedicatedDriver: 'Conductor dedicado',
        totalFlexibility: 'Flexibilidad total',
        waitIncluded: 'Espera incluida',
        multipleTrips: 'Viajes múltiples',
        immaculateVehicle: 'Vehículo inmaculado',
        eveningAttire: 'Conductor con traje de noche',
        discretionGuaranteed: 'Discreción garantizada',
        flexibleSchedule: 'Horarios flexibles',
      },
    },
    vehicles: {
      title: 'Vehículo Premium',
      subtitle: 'Citroën C4 Plus 2025, mantenido con el mayor cuidado, para garantizarle confort, silencio y serenidad.',
      passengers: 'pasajeros',
      luggage: 'equipaje',
      includedEquipment: 'Equipamiento incluido:',
      bookVehicle: 'Reservar este vehículo',
      requestQuote: 'Solicitar presupuesto personalizado →',
      availability: 'Citroën C4 Plus disponible 24/7 en la Costa Azul',
      availabilityDesc: 'Vehículo híbrido última generación con tecnología Advanced Comfort. Mantenimiento oficial, seguro a todo riesgo y conductor experimentado para cada viaje.',
      bookNow: 'Reservar ahora',
      category: 'Sedán Híbrido Premium',
      features: {
        spacious: 'Habitáculo espacioso y silencioso',
        acoustic: 'Aislamiento acústico reforzado',
        suspension: 'Suspensiones Advanced Comfort',
        seats: 'Asientos Advanced Comfort ',
        hybrid: 'Motorización híbrida silenciosa en ciudad',
      },
    },
    pricing: {
      title: 'Tarifas Transparentes',
      subtitle: 'Precios justos, conocidos de antemano. Sin cargos ocultos, para un servicio con total confianza.',
      tollIncluded: 'Peajes incluidos',
      book: 'Reservar',
      fixedPrices: 'Precios fijos',
      fixedPricesDesc: 'Tarifas establecidas de antemano, sin sorpresas en la factura final.',
      allInclusive: 'Todo incluido',
      allInclusiveDesc: 'Gastos de servicio, peajes y seguro incluidos en las tarifas.',
      flexiblePayment: 'Pago flexible',
      flexiblePaymentDesc: 'Efectivo, tarjeta de crédito o transferencia, elija su método de pago.',
      customQuote: '¿Necesita una tarifa personalizada?',
      customQuoteDesc: 'Cada solicitud merece una atención especial. Una tarifa a medida está disponible para sus necesidades específicas.',
      requestQuote: 'Solicitar presupuesto',
      priceDesc: 'Precio final calculado según dirección reservada.',
    },
    reviews: {
      title: 'Reseñas de Google',
      googleReviews: 'reseñas de Google',
      subtitle: 'Descubra lo que los clientes piensan de los servicios de Riviera Signature VTC.',
      yourOpinionMatters: 'Tu opinión importa',
      shareExperience: '¿Ha utilizado nuestros servicios? Comparta su experiencia con la comunidad y ayude a otros viajeros a descubrir Riviera Signature VTC.',
      seeAllReviews: 'Ver todas las reseñas de Google →',
      googleRating: 'Puntuación Google',
      recommended: 'Recomendado',
      responseTime: 'Respuesta reseñas',
      since: 'Desde',
      reviewTexts: {
        review1: '¡Servicio excepcional! Viaje Niza-Mónaco en total confort y silencio. Conductor muy profesional y puntual. Recomiendo encarecidamente para todos sus viajes en la Costa Azul.',
        review2: 'Riviera Signature VTC es ahora mi elección exclusiva para traslados al aeropuerto. Vehículo siempre impecable, muy cómodo. Servicio premium a precio justo.',
        review3: 'Utilizamos Riviera Signature VTC para nuestra boda en Cannes. Servicio impecable, vehículo suntuoso. Perfecto para una llegada notable.',
        review4: 'A disposición para un día de reuniones entre Niza y Mónaco. Vehículo muy cómodo, silencio de marcha apreciable para llamar. Conductor discreto y profesional.',
      },
      timeAgo: {
        week1: 'hace 1 semana',
        weeks2: 'hace 2 semanas',
        weeks3: 'hace 3 semanas',
        month1: 'hace 1 mes',
      },
    },
    contact: {
      title: 'Contacto',
      subtitle: 'Conductor a su disposición 24h/24 y 7d/7 para responder a todas sus solicitudes y acompañarle en sus desplazamientos.',
      coordinates: 'Coordenadas',
      phone: 'Teléfono',
      available247: 'Disponible 24h/24, 7d/7',
      email: 'Email',
      responseTime: 'Respuesta media en 2h',
      serviceArea: 'Zona de servicio',
      serviceHours: 'Horarios de servicio',
      mondaySunday: 'Lunes - Domingo',
      allDay: '24h/24',
      holidays: 'Días festivos',
      serviceMaintained: 'Servicio mantenido',
      reservations: 'Reservas',
      onlineOrPhone: 'En línea o por teléfono',
      quickContact: 'Contacto rápido',
      firstName: 'Nombre',
      lastName: 'Apellido',
      phonePlaceholder: 'Teléfono',
      emailPlaceholder: 'Email',
      subjectPlaceholder: 'Asunto de su solicitud',
      subjects: {
        reservation: 'Reserva',
        information: 'Solicitud de información',
        quote: 'Solicitud de presupuesto',
        complaint: 'Reclamación',
        other: 'Otro',
      },
      messagePlaceholder: 'Su mensaje...',
      sendMessage: 'Enviar mensaje',
      followUs: 'Síguenos',
    },
    footer: {
      description: 'Transporte premium en la Costa Azul con Citroën C4 Plus 2025.',
      services: 'Servicios',
      privateTransfer: 'Traslado Privado',
      airportTransfer: 'Traslado Aeropuerto',
      trainTransfer: 'Traslado Estación',
      disposal: 'A Disposición',
      eventTransfer: 'Traslado Eventos',
      contact: 'Contacto',
      allRightsReserved: 'Todos los derechos reservados.',
    },
    booking: {
      title: 'Solicitud de reserva',
      serviceType: 'Tipo de servicio *',
      selectService: 'Seleccione un servicio',
      pickupDate: 'Fecha de recogida *',
      time: 'Hora *',
      pickupAddress: 'Dirección de recogida *',
      pickupPlaceholder: 'Dirección completa / aeropuerto / estación',
      destination: 'Destino',
      destinationPlaceholder: 'Dirección / aeropuerto / estación / restaurante',
      passengers: 'Número de pasajeros',
      passenger: 'pasajero',
      passengersPlural: 'pasajeros',
      yourInfo: 'Su información',
      fullName: 'Nombre completo *',
      namePlaceholder: 'Su nombre',
      phone: 'Teléfono *',
      email: 'Email *',
      notes: 'Notas especiales',
      notesPlaceholder: 'Info adicional (silla de bebé, equipaje voluminoso, etc.)',
      cancel: 'Cancelar',
      sendRequest: 'Enviar solicitud',
      sending: 'Enviando...',
      estimatedDistance: 'Distancia estimada',
      estimatedPrice: 'Precio estimado',
      error: 'Error',
      fillRequired: 'Por favor complete todos los campos obligatorios.',
      reservationSent: '¡Reserva enviada! ✅',
      requestSent: 'Su solicitud ha sido enviada con ID',
      emailError: 'Error al enviar email',
      emailErrorDesc: 'Se produjo un error al enviar los correos de confirmación. Contáctenos directamente.',
      reservationSentSimple: 'Su reserva ha sido enviada.',
      serviceTypes: {
        transfer: 'Traslado',
        airportTrain: 'Traslado aeropuerto/estación',
        disposal: 'A disposición',
        event: 'Traslado evento',
      },
    },
    common: {
      darkMode: 'Modo oscuro',
      lightMode: 'Modo claro',
    },
  },

  ru: {
    nav: {
      home: 'Главная',
      services: 'Услуги',
      vehicles: 'Транспорт',
      pricing: 'Цены',
      contact: 'Контакты',
      book: 'Забронировать',
      backToSite: 'Вернуться на сайт',
      administration: 'Администрирование',
    },
    hero: {
      tagline: 'Премиальный транспорт на Лазурном берегу',
      description: 'VTC-сервис высокого класса, предлагающий элегантные и спокойные поездки между Ниццей, Каннами, Монако и основными региональными направлениями. Каждая поездка отличается персонализированным подходом, сочетающим пунктуальность, конфиденциальность и комфорт.',
      bookNow: 'Забронировать сейчас',
      discoverServices: 'Узнать об услугах',
      since: 'С',
      service: 'Сервис',
      satisfaction: 'Удовлетворение',
    },
    services: {
      title: 'Премиум услуги',
      subtitle: 'Полный спектр транспортных услуг высокого класса, адаптированных к вашим личным и профессиональным потребностям.',
      customService: 'Нужна индивидуальная услуга?',
      requestQuote: 'Запросить персональное предложение →',
      privateTransfer: 'Частный трансфер',
      privateTransferDesc: 'Частный транспорт для ваших ежедневных поездок по Лазурному берегу',
      airportTransfer: 'Трансфер в аэропорт',
      airportTransferDesc: 'Услуга трансфера в аэропорт Ницца Лазурный берег и все региональные аэропорты',
      trainTransfer: 'Трансфер на вокзал',
      trainTransferDesc: 'Комфортные соединения со всеми вокзалами Лазурного берега с гарантированной пунктуальностью',
      disposal: 'В распоряжении',
      disposalDesc: 'Автомобиль и водитель в вашем распоряжении для поездок по Лазурному берегу',
      eventTransfer: 'Трансфер на мероприятие',
      eventTransferDesc: 'Премиум транспорт для ваших мероприятий, свадеб и вечеринок на Ривьере',
      features: {
        customTrips: 'Индивидуальные маршруты',
        pickupAddress: 'Подача по указанному адресу',
        punctuality: 'Гарантированная пунктуальность',
        flexiblePayment: 'Гибкая оплата',
        flightTracking: 'Отслеживание рейса в реальном времени',
        personalWelcome: 'Персональная встреча',
        luggageHelp: 'Помощь с багажом',
        waitTimeIncluded: 'Время ожидания включено',
        niceStation: 'Вокзал Ниццы',
        cannesStation: 'Вокзал Канн',
        monacoStation: 'Вокзал Монако',
        trainTracking: 'Отслеживание поездов в реальном времени',
        dedicatedDriver: 'Личный водитель',
        totalFlexibility: 'Полная гибкость',
        waitIncluded: 'Ожидание включено',
        multipleTrips: 'Множественные поездки',
        immaculateVehicle: 'Безупречный автомобиль',
        eveningAttire: 'Водитель в вечернем костюме',
        discretionGuaranteed: 'Гарантированная конфиденциальность',
        flexibleSchedule: 'Гибкий график',
      },
    },
    vehicles: {
      title: 'Премиум автомобиль',
      subtitle: 'Citroën C4 Plus 2025, обслуживаемая с максимальной тщательностью, чтобы гарантировать вам комфорт, тишину и спокойствие.',
      passengers: 'пассажиров',
      luggage: 'багажа',
      includedEquipment: 'Включённое оборудование:',
      bookVehicle: 'Забронировать автомобиль',
      requestQuote: 'Запросить персональное предложение →',
      availability: 'Citroën C4 Plus доступна 24/7 на Лазурном берегу',
      availabilityDesc: 'Гибридный автомобиль последнего поколения с технологией Advanced Comfort. Официальное обслуживание, полная страховка и опытный водитель для каждой поездки.',
      bookNow: 'Забронировать',
      category: 'Премиум гибридный седан',
      features: {
        spacious: 'Просторный и тихий салон',
        acoustic: 'Усиленная звукоизоляция',
        suspension: 'Подвеска Advanced Comfort',
        seats: 'Сиденья Advanced Comfort ',
        hybrid: 'Тихая гибридная моторизация в городе',
      },
    },
    pricing: {
      title: 'Прозрачные цены',
      subtitle: 'Справедливые цены, известные заранее. Никаких скрытых платежей для обслуживания с полным доверием.',
      tollIncluded: 'Дорожные сборы включены',
      book: 'Забронировать',
      fixedPrices: 'Фиксированные цены',
      fixedPricesDesc: 'Тарифы установлены заранее, никаких сюрпризов в итоговом счёте.',
      allInclusive: 'Всё включено',
      allInclusiveDesc: 'Сервисные сборы, дорожные пошлины и страховка включены в тарифы.',
      flexiblePayment: 'Гибкая оплата',
      flexiblePaymentDesc: 'Наличные, банковская карта или перевод - выберите удобный способ оплаты.',
      customQuote: 'Нужен индивидуальный тариф?',
      customQuoteDesc: 'Каждый запрос заслуживает особого внимания. Индивидуальный тариф доступен для ваших конкретных потребностей.',
      requestQuote: 'Запросить предложение',
      priceDesc: 'Окончательная цена рассчитывается по забронированному адресу.',
    },
    reviews: {
      title: 'Отзывы Google',
      googleReviews: 'отзывов Google',
      subtitle: 'Узнайте, что клиенты думают об услугах Riviera Signature VTC.',
      yourOpinionMatters: 'Ваше мнение важно',
      shareExperience: 'Вы пользовались нашими услугами? Поделитесь своим опытом с сообществом и помогите другим путешественникам открыть для себя Riviera Signature VTC.',
      seeAllReviews: 'Все отзывы Google →',
      googleRating: 'Рейтинг Google',
      recommended: 'Рекомендовано',
      responseTime: 'Ответ на отзывы',
      since: 'С',
      reviewTexts: {
        review1: 'Исключительный сервис! Поездка Ницца-Монако в полном комфорте и тишине. Очень профессиональный и пунктуальный водитель. Настоятельно рекомендую для всех поездок по Лазурному берегу.',
        review2: 'Riviera Signature VTC теперь мой эксклюзивный выбор для трансферов в аэропорт. Всегда безупречный автомобиль, очень комфортный. Премиум сервис по справедливой цене.',
        review3: 'Мы использовали Riviera Signature VTC для нашей свадьбы в Каннах. Безупречный сервис, роскошный автомобиль. Идеально для впечатляющего прибытия.',
        review4: 'В распоряжении на целый день встреч между Ниццей и Монако. Очень комфортный автомобиль, тихий ход ценен для телефонных разговоров. Скромный и профессиональный водитель.',
      },
      timeAgo: {
        week1: '1 неделю назад',
        weeks2: '2 недели назад',
        weeks3: '3 недели назад',
        month1: '1 месяц назад',
      },
    },
    contact: {
      title: 'Контакты',
      subtitle: 'Водитель в вашем распоряжении 24/7 для ответа на все ваши запросы и сопровождения в поездках.',
      coordinates: 'Контактная информация',
      phone: 'Телефон',
      available247: 'Доступен 24/7',
      email: 'Email',
      responseTime: 'Среднее время ответа 2ч',
      serviceArea: 'Зона обслуживания',
      serviceHours: 'Часы работы',
      mondaySunday: 'Понедельник - Воскресенье',
      allDay: '24/7',
      holidays: 'Праздничные дни',
      serviceMaintained: 'Сервис работает',
      reservations: 'Бронирование',
      onlineOrPhone: 'Онлайн или по телефону',
      quickContact: 'Быстрая связь',
      firstName: 'Имя',
      lastName: 'Фамилия',
      phonePlaceholder: 'Телефон',
      emailPlaceholder: 'Email',
      subjectPlaceholder: 'Тема вашего запроса',
      subjects: {
        reservation: 'Бронирование',
        information: 'Запрос информации',
        quote: 'Запрос предложения',
        complaint: 'Жалоба',
        other: 'Другое',
      },
      messagePlaceholder: 'Ваше сообщение...',
      sendMessage: 'Отправить сообщение',
      followUs: 'Подписывайтесь',
    },
    footer: {
      description: 'Премиальный транспорт на Лазурном берегу с Citroën C4 Plus 2025.',
      services: 'Услуги',
      privateTransfer: 'Частный трансфер',
      airportTransfer: 'Трансфер в аэропорт',
      trainTransfer: 'Трансфер на вокзал',
      disposal: 'В распоряжении',
      eventTransfer: 'Трансфер на мероприятия',
      contact: 'Контакты',
      allRightsReserved: 'Все права защищены.',
    },
    booking: {
      title: 'Запрос на бронирование',
      serviceType: 'Тип услуги *',
      selectService: 'Выберите услугу',
      pickupDate: 'Дата подачи *',
      time: 'Время *',
      pickupAddress: 'Адрес подачи *',
      pickupPlaceholder: 'Полный адрес / аэропорт / вокзал',
      destination: 'Пункт назначения',
      destinationPlaceholder: 'Адрес / аэропорт / вокзал / ресторан',
      passengers: 'Количество пассажиров',
      passenger: 'пассажир',
      passengersPlural: 'пассажиров',
      yourInfo: 'Ваша информация',
      fullName: 'Полное имя *',
      namePlaceholder: 'Ваше имя',
      phone: 'Телефон *',
      email: 'Email *',
      notes: 'Особые пожелания',
      notesPlaceholder: 'Дополнительно (детское кресло, крупный багаж и т.д.)',
      cancel: 'Отмена',
      sendRequest: 'Отправить запрос',
      sending: 'Отправка...',
      estimatedDistance: 'Расчётное расстояние',
      estimatedPrice: 'Расчётная цена',
      error: 'Ошибка',
      fillRequired: 'Пожалуйста, заполните все обязательные поля.',
      reservationSent: 'Бронирование отправлено! ✅',
      requestSent: 'Ваш запрос отправлен с ID',
      emailError: 'Ошибка отправки email',
      emailErrorDesc: 'Произошла ошибка при отправке подтверждающих писем. Свяжитесь с нами напрямую.',
      reservationSentSimple: 'Ваше бронирование отправлено.',
      serviceTypes: {
        transfer: 'Трансфер',
        airportTrain: 'Трансфер аэропорт/вокзал',
        disposal: 'В распоряжении',
        event: 'Трансфер на мероприятие',
      },
    },
    common: {
      darkMode: 'Тёмный режим',
      lightMode: 'Светлый режим',
    },
  },
};
